(() => {
const init = (root = document) => {
root.querySelectorAll('[data-gvs-header]').forEach(header => {
if (header.dataset.ready) return; header.dataset.ready = 'true';
const groups = [...header.querySelectorAll('.gvs-nav__group')];
const mobile = header.querySelector('.gvs-mobile-toggle');
let timer;
const close = () => groups.forEach(group => group.open = false);
groups.forEach(group => {
group.querySelector('summary').addEventListener('click',event=>{if(event.detail>0&&matchMedia('(min-width:750px) and (hover:hover)').matches){event.preventDefault();groups.forEach(other=>{if(other!==group)other.open=false;});group.open=true;}});
group.addEventListener('mouseenter', () => {
if (!matchMedia('(min-width:750px) and (hover:hover)').matches) return;
clearTimeout(timer); groups.forEach(other => {if (other !== group) other.open = false;}); group.open = true;
});
group.addEventListener('mouseleave', () => {
if (matchMedia('(min-width:750px) and (hover:hover)').matches) timer = setTimeout(() => {if (!group.contains(document.activeElement)) group.open = false;}, 180);
});
group.addEventListener('toggle', () => {if (group.open) groups.forEach(other => {if (other !== group) other.open = false;});});
});
mobile.addEventListener('click', () => {const open = header.classList.toggle('is-mobile-open'); mobile.setAttribute('aria-expanded', open); if (!open) close();});
header.addEventListener('keydown', event => {if (event.key === 'Escape') {const active = groups.find(group => group.open);close();if(active)active.querySelector('summary').focus();else{header.classList.remove('is-mobile-open');mobile.setAttribute('aria-expanded','false');mobile.focus();}}});
header.querySelectorAll('a').forEach(a => a.addEventListener('click',()=>{close();header.classList.remove('is-mobile-open');mobile.setAttribute('aria-expanded','false');}));
document.addEventListener('click', event => {if (!header.contains(event.target)) close();});
});
root.querySelectorAll('[data-gvs-carousel]').forEach(carousel => {
if (carousel.dataset.ready) return; carousel.dataset.ready = 'true';
const slides = [...carousel.querySelectorAll('[data-slide]')];
const tabs = [...carousel.querySelectorAll('[data-slide-to]')];
const pause = carousel.querySelector('[data-pause]');
const reduced = matchMedia('(prefers-reduced-motion:reduce)');
let index = 0, paused = reduced.matches, timer, startX = null;
const videoDuration = Number(carousel.dataset.duration) || 5000;
const slideDuration = () => slides[index].querySelector('video') ? videoDuration : 3000;
const stop = () => clearTimeout(timer);
const schedule = () => {stop();
if (!slides.length) return;
const duration = slideDuration();
carousel.style.setProperty('--gvs-slide-duration', `${duration}ms`);
if (!paused && !document.hidden && slides.length > 1 && !(carousel.contains(document.activeElement) && document.activeElement.matches(':focus-visible')))timer=setTimeout(()=>show(index+1),duration);};
const videos = () => slides.forEach((slide,i) => slide.querySelectorAll('video').forEach(video=>{if(i===index&&!paused&&!document.hidden) video.play().catch(()=>{});else video.pause();}));
const show = next => {index = (next+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.inert=i!==index;slide.setAttribute('aria-hidden',i!==index);});tabs.forEach((tab,i)=>{if(i===index)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});videos();schedule();};
const reflect = () => {pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);};
pause.addEventListener('click',()=>{paused=!paused;reflect();videos();schedule();});
tabs.forEach((tab,i)=>tab.addEventListener('click',()=>show(i)));
carousel.addEventListener('focusin',schedule);carousel.addEventListener('focusout',()=>setTimeout(schedule,0));
carousel.addEventListener('pointerdown',event=>{startX=event.clientX;});carousel.addEventListener('pointerup',event=>{if(startX!==null&&Math.abs(event.clientX-startX)>55)show(index+(event.clientX<startX?1:-1));startX=null;});
document.addEventListener('visibilitychange',()=>{videos();schedule();});
reduced.addEventListener('change',event=>{paused=event.matches;reflect();videos();schedule();});
carousel.addEventListener('gvs:dispose',()=>{stop();slides.forEach(s=>s.querySelectorAll('video').forEach(v=>v.pause()));});
reflect();show(0);
});
root.querySelectorAll('.gvs-hotspot').forEach(link=>link.addEventListener('click',()=>{const target=document.getElementById(link.hash.slice(1));if(target)target.open=true;}));
};
init();document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-gvs-carousel]').forEach(el=>el.dispatchEvent(new Event('gvs:dispose'))));
})();

async function loadCatalogPage(link, automatic) {
  if (link.dataset.loadingActive) return;
  const catalog = link.closest('.gvs-catalog');
  const grid = catalog.querySelector('.gvs-catalog__grid');
  const status = catalog.querySelector('.gvs-load-status');
  const label = link.textContent;
  link.dataset.loadingActive = 'true';
  link.setAttribute('aria-disabled', 'true');
  grid.setAttribute('aria-busy', 'true');
  link.textContent = link.dataset.loading;
  status.textContent = '';
  try {
    const response = await fetch(link.href, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Load failed');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextGrid = page.querySelector('.gvs-catalog__grid');
    if (!nextGrid) throw new Error('Grid missing');
    const cards = [...nextGrid.querySelectorAll('.gvs-card')];
    if (!cards.length) throw new Error('Products missing');
    grid.append(...cards);
    const nextLink = page.querySelector('[data-gvs-load-more]');
    if (nextLink) {
      link.href = nextLink.getAttribute('href');
    } else {
      status.textContent = link.dataset.complete;
      link.hidden = true;
    }
    if (!automatic) cards[0].querySelector('a')?.focus({ preventScroll: true });
  } catch (error) {
    status.textContent = link.dataset.error;
  } finally {
    delete link.dataset.loadingActive;
    link.removeAttribute('aria-disabled');
    grid.removeAttribute('aria-busy');
    link.textContent = label;
  }
}

document.addEventListener('click', event => {
  const link = event.target.closest('[data-gvs-load-more]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  loadCatalogPage(link, false);
});

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    for (const {target, isIntersecting} of entries) {
      if (isIntersecting && !target.hidden && target.isConnected) loadCatalogPage(target, true);
    }
  }, { rootMargin: '0px 0px 350px' });
  const observe = root => root.querySelectorAll('[data-gvs-load-more]').forEach(link => observer.observe(link));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe(document), {once: true});
  else observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-gvs-load-more]').forEach(link => observer.unobserve(link)));
}

document.addEventListener('click', event => {
  const dot = event.target.closest('[data-gvs-dot]');
  if (!dot || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const card = dot.closest('.gvs-card');
  const content = dot.nextElementSibling?.content;
  if (!card || !content) return;
  event.preventDefault();
  for (const selector of ['.gvs-card__media', '.gvs-card__info']) {
    card.querySelector(selector).replaceWith(content.querySelector(selector).cloneNode(true));
  }
  for (const choice of card.querySelectorAll('[data-gvs-dot]')) choice.setAttribute('aria-pressed', String(choice === dot));
});
document.addEventListener('keydown', event => {
  if(event.key === ' ' && event.target.matches('[data-gvs-dot]')) { event.preventDefault(); event.target.click(); }
});
